import { Injectable } from '@angular/core';
import { BannerState } from '@core/states/banner.state';
import { environment } from '@environment';
import { ImpersonationBannerService } from '@features/impersonation/impersonation-banner.service';
import { BannerInfo } from '@yourcause/common/banner';
import { I18nService } from '@yourcause/common/i18n';
import { AttachYCState, BaseYCService } from '@yourcause/common/state';

@AttachYCState(BannerState)
@Injectable({ providedIn: 'root' })
export class BannerService extends BaseYCService<BannerState> {

  constructor (
    private impersonationBannerService: ImpersonationBannerService,
    private i18n: I18nService
  ) {
    super();
  }

  get banners () {
    return this.get('banners');
  }

  setManagerPortalBanners () {
    const banners: BannerInfo[] = [];

    const impersonationBanner = this.impersonationBannerService.getImpersonationBanner();

    if (impersonationBanner) {
      banners.push(impersonationBanner);
    }
    if (environment.isUat) {
      banners.push(this.getUatBanner());
    }

    this.setBanners(banners);
  }

  setApplicantPortalBanners () {
    const banners: BannerInfo[] = [];
    if (environment.isUat) {
      banners.push(this.getUatBanner());
    }

    this.setBanners(banners);
  }

  setLoginBanners () {
    const banners: BannerInfo[] = [];
    if (environment.isUat) {
      banners.push(this.getUatBanner());
    }
    this.setBanners(banners);
  }

  getUatBanner (): BannerInfo {
    return {
      visible: true,
      message: this.i18n.translate(
        'common:textYouAreInUatEnv',
        {},
        'Please note that you are in the GrantsConnect UAT environment.'
      ),
      buttonText: '',
      onButtonClick: null
    };
  }

  setBanners (banners: BannerInfo[]) {
    this.set('banners', banners);
  }

}
